import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Fragment } from "react";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import OmniAssessmentValueTextFab from "../ui/omniAssessmentValueTextFab";
import OmniTextField from "../ui/omniTextField";

const getAnswerTextAsHTML = text => {
  return { __html: `${text}` };
};

const QuestionDateDisplay = props => {
  const { question, onAnswerSelected, startNextTimer } = props;

  const theme = useTheme();

  const defaultDelay = 500;

  const [validAnswerSelected, setValidAnswerSelected] = useState(question.answerValue != null);

  const [unsure, setUnsure] = useState(
    question.answerValue && question.answerValue[0] === "unsure" ? true : false,
  );

  let dayInput = useRef(null);
  let yearInput = useRef(null);

  const [monthMM, setMonthMM] = useState("");
  const [monthValid, setMonthValid] = useState(false);
  const [dayDD, setDayDD] = useState("");
  const [dayValid, setDayValid] = useState(false);
  const [yearYYYY, setYearYYYY] = useState("");
  const [yearValid, setYearValid] = useState(false);

  useEffect(() => {
    if (
      question.answerValue == null ||
      (question.answerValue && question.answerValue[0] === "unsure")
    ) {
      setMonthMM("");
      setDayDD("");
      setYearYYYY("");
    } else {
      setMonthMM(
        question.answerValue ? question.answerValue[0].substring(5, 7).replace(/[^0-9]/g, "") : "",
      );
      setDayDD(
        question.answerValue ? question.answerValue[0].substring(8, 10).replace(/[^0-9]/g, "") : "",
      );
      setYearYYYY(
        question.answerValue ? question.answerValue[0].substring(0, 4).replace(/[^0-9]/g, "") : "",
      );
    }
  }, [question]);

  useEffect(() => {
    // 2023-02-16T21:39:04.108Z"

    let theMonth = parseInt(monthMM);
    let newMonthValid = theMonth >= 1 && theMonth <= 12;
    setMonthValid(newMonthValid);

    let theDay = parseInt(dayDD);
    let newDayValid = theDay >= 1 && theDay <= 31;
    setDayValid(newDayValid);

    let currentYear = new Date().getFullYear();

    let theYear = parseInt(yearYYYY);
    let newYearValid = theYear > 1000 && theYear <= currentYear;
    setYearValid(newYearValid);

    let theDate = `${yearYYYY}-${monthMM.padStart(2, "0")}-${dayDD.padStart(2, "0")}T01:01:01.010Z`;

    theDate = new Date(theDate);

    if (!newMonthValid || !newDayValid || !newYearValid) {
      onAnswerSelected(null);
      setValidAnswerSelected(false);
    } else if (theDate instanceof Date && !isNaN(theDate)) {
      //valid date
      onAnswerSelected([theDate.toISOString()]);
      setUnsure(false);
      setValidAnswerSelected(true);
    } else if (!unsure) {
      onAnswerSelected(null);
      // setValidAnswerSelected(false);
    }
  }, [
    monthMM,
    dayDD,
    yearYYYY,
    unsure,
    setMonthValid,
    setDayValid,
    setYearValid,
    setUnsure,
    onAnswerSelected,
    setValidAnswerSelected,
  ]);

  return (
    <Fragment>
      <Grid
        sx={{ width: "100%" }}
        container
        item
        direction="row"
        spacing={2}
        justifyContent="center"
      >
        <Grid item xs={12} padding={1} justifyContent="center">
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              width: "100%",
              flexDirection: "row",
              marginLeft: `-${theme.spacing(2)}`,
            }}
          >
            <OmniTextField
              sx={{ width: "70px" }}
              label="Month"
              type="textInput"
              name={uuid()} //prevents AutoComplete Suggestions
              variant="outlined"
              id={"region"}
              value={monthMM}
              error={!monthValid}
              onFocus={event => event.target.select()}
              onChange={event => {
                let onlyNums = event.target.value.replace(/[^0-9]/g, "");
                onlyNums = onlyNums.slice(0, 2);
                setMonthMM(onlyNums);
                setUnsure(false);
                if (onlyNums.length === 2) {
                  dayInput.current.focus();
                }
              }}
              placeholder={"MM"}
              onKeyPress={e => {
                if (e.key === "Enter" && validAnswerSelected) {
                  startNextTimer(defaultDelay);
                }
              }}
              autoFocus
            />
            <OmniTextField
              sx={{ width: "70px", marginLeft: theme.spacing(1), marginRight: theme.spacing(1) }}
              label="Day"
              type="textInput"
              name={uuid()} //prevents AutoComplete Suggestions
              variant="outlined"
              id={"region"}
              value={dayDD}
              error={!dayValid}
              inputRef={dayInput}
              onFocus={event => event.target.select()}
              onChange={event => {
                let onlyNums = event.target.value.replace(/[^0-9]/g, "");
                onlyNums = onlyNums.slice(0, 2);
                setDayDD(onlyNums);
                setUnsure(false);
                if (onlyNums.length === 2) {
                  yearInput.current.focus();
                }
              }}
              placeholder={"DD"}
              onKeyPress={e => {
                if (e.key === "Enter" && validAnswerSelected) {
                  startNextTimer(defaultDelay);
                }
              }}
            />
            <OmniTextField
              sx={{ width: "70px" }}
              label="Year"
              type="textInput"
              name={uuid()} //prevents AutoComplete Suggestions
              variant="outlined"
              id={"region"}
              value={yearYYYY}
              error={!yearValid}
              inputRef={yearInput}
              onFocus={event => event.target.select()}
              onChange={event => {
                let onlyNums = event.target.value.replace(/[^0-9]/g, "");
                onlyNums = onlyNums.slice(0, 4);
                setYearYYYY(onlyNums);
                setUnsure(false);
              }}
              placeholder={"YYYY"}
              onKeyPress={e => {
                if (e.key === "Enter" && validAnswerSelected) {
                  startNextTimer(defaultDelay);
                }
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={11} sx={{ marginTop: theme.spacing(2) }}>
          <Grid
            id={`questionGrid1`}
            container
            item
            xs={12}
            justifyContent="center"
            spacing={2}
            sx={{ width: "100%" }}
            // sx={{ marginLeft: "0", padding: "0", overflowX: "hidden" }}
          >
            <OmniAssessmentValueTextFab
              key={`answerOption${uuid()}`}
              color="primary"
              size="large"
              variant={"outlined"}
              onClick={e => {
                setUnsure(true);
                onAnswerSelected(["unsure"]);
                startNextTimer(defaultDelay);
              }}
              sx={{ width: "100%", "&:hover": { color: theme.palette.primary.contrastText } }}
            >
              <Grid
                container
                justifyContent="center"
                direction="row"
                sx={{ width: "100%", alignItems: "center" }}
              >
                <Grid item justifySelf="center" xs>
                  <Typography
                    variant="button"
                    dangerouslySetInnerHTML={getAnswerTextAsHTML("I don't know")}
                  />
                </Grid>
                {unsure && (
                  <CheckCircleRoundedIcon
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 16,
                      maxWidth: "32px",
                      maxHeight: "32px",
                      alignSelf: "baseline",
                    }}
                  />
                )}
              </Grid>
            </OmniAssessmentValueTextFab>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default QuestionDateDisplay;
